module.exports = __webpack_public_path__ + "static/cag1-aa33d69a56d2c648f9f62c4bdffaf2c3.png";